import { useLocation } from 'react-router-dom';
import { useHubTheme } from '@/context/HubThemeContext';

export default function AnimatedBackground() {
  const location = useLocation();
  const isMapPage = location.pathname === '/drivershub/karte';
  const { rgb } = useHubTheme();
  const { r, g, b } = rgb || { r: 245, g: 158, b: 11 };

  if (isMapPage) return null;

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0 select-none" style={{ background: '#050608' }}>
      {/* Primary Dutch Cabin Glow (Header Top Center) */}
      <div 
        className="absolute top-0 left-1/2 rounded-full pointer-events-none transition-all duration-500"
        style={{
          transform: 'translateX(-50%)',
          width: '80vw',
          height: '450px',
          background: `radial-gradient(ellipse at top, rgba(${r}, ${g}, ${b}, 0.18) 0%, rgba(${Math.round(r * 0.9)}, ${Math.round(g * 0.7)}, ${Math.round(b * 0.3)}, 0.05) 40%, transparent 70%)`,
          opacity: 0.95,
          filter: 'blur(30px)',
        }}
      />

      {/* Warm Double-Burner Ambient Glow (Top-Right) */}
      <div 
        className="absolute rounded-full pointer-events-none transition-all duration-500"
        style={{
          top: '-15%',
          right: '-10%',
          width: '55vw',
          height: '55vw',
          maxWidth: '850px',
          maxHeight: '850px',
          background: `radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.13) 0%, rgba(${r}, ${g}, ${b}, 0.02) 40%, transparent 70%)`,
          filter: 'blur(40px)',
        }}
      />

      {/* Highway Headlight Mist Illumination (Bottom-Left) */}
      <div 
        className="absolute rounded-full pointer-events-none transition-all duration-500"
        style={{
          bottom: '-20%',
          left: '-10%',
          width: '60vw',
          height: '60vw',
          maxWidth: '900px',
          background: `radial-gradient(circle, rgba(255, 255, 255, 0.06) 0%, rgba(${r}, ${g}, ${b}, 0.04) 40%, transparent 70%)`,
          filter: 'blur(45px)',
        }}
      />

      {/* Rear Truck Taillight Soft Red Accent Glow (Bottom-Right) */}
      <div 
        className="absolute rounded-full pointer-events-none"
        style={{
          bottom: '-15%',
          right: '-10%',
          width: '45vw',
          height: '45vw',
          maxWidth: '700px',
          background: 'radial-gradient(circle, rgba(239, 68, 68, 0.05) 0%, rgba(220, 38, 38, 0.01) 40%, transparent 70%)',
          filter: 'blur(50px)',
        }}
      />

      {/* Smooth Dark Vignette */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at 50% 50%, transparent 30%, rgba(3, 4, 6, 0.85) 100%)',
        }}
      />
    </div>
  );
}
